import React from "react";
import Layout from "../components/layout";
import Seo from "../components/head";

import Hero from "../components/landing/hero";
import SignalStrip from "../components/landing/signal-strip";
import RolePaths from "../components/landing/role-paths";
import FeaturedWork from "../components/landing/featured-work";
import ExperienceProof from "../components/landing/experience-proof";
import CTA from "../components/landing/cta";

const IndexPage = () => {
  return (
    <Layout>
      <Hero />
      <SignalStrip />
      <RolePaths />
      <FeaturedWork />
      <ExperienceProof />
      <CTA />
    </Layout>
  );
};

export default IndexPage;

export const Head = () => <Seo title="Home" />;